import {Routes} from '@angular/router';
import {ExcelMemoContentComponent} from './components/excel-memo-content/excel-memo-content.component';
import {ExcelMemoTemplateContentComponent} from "./components/excel-memo-template-content/excel-memo-template-content.component";
import { PlatformLinkCreatorComponent } from '@shared/components/platform-tool/platform-link-creator/platform-link-creator.component';
import { PlatformToolContainerComponent } from '@shared/components/platform-tool/platform-tool-container/platform-tool-container.component';
import { ExcelViewMemoComponent } from './components/excel-view-memo/excel-view-memo.component';

export const ExcelMemoRoutes: Routes = [
  /*{
    path: 'planning/:memoType',
    component: ExcelMemoContentComponent
  },
  {
    path: 'planning/:memoType/:id',
    component: ExcelMemoTemplateContentComponent
  },
  {
    path: 'planning/:memoType/:id/view',
    component: ExcelViewMemoComponent
  },*/
  {
    path: 'planning/:memoType',
    children: [
      {
        path: ':magicLinkId',
        component: PlatformToolContainerComponent
      },
      {
        path: '',
        component: PlatformLinkCreatorComponent
      }
    ]
  },
  // {
  //   path: 'rate-memo/:memoType',
  //   component: RateMemoContentComponent
  // },
  {
    path: 'rate-memo/:memoType',
    children: [
      {
        path: ':magicLinkId',
        component: PlatformToolContainerComponent
      },
      {
        path: '',
        component: PlatformLinkCreatorComponent
      }
    ]
  }
  ,
  // {
  //   path: 'rate-memo/wt/:id',
  //   component: WithholdingTaxMemoContentComponent
  // },
  // {
  //   path: 'rate-memo/ct/:id',
  //   component: CorporateTaxMemoContentComponent
  // },
  // {
  //   path: 'rate-memo/:memoType/:id/view',
  //   component: ViewMemoComponent
  // }
];
